import * as React from "react";
import * as UrlUtil from "../utils/url-util";
import { useSearchParams, useRouter } from "next/navigation";

export const useUrlValidation = () => {
  const searchParams = useSearchParams();
  const router = useRouter();

  React.useEffect(() => {
    const queryParams = UrlUtil.parseQueryOf(
      UrlUtil.getQueryParamString(searchParams),
    );
    if (!UrlUtil.checkGrafferUrl(queryParams.to as string)) {
      router.push("/login");
    }
  }, [router, searchParams]);
};
